import { Routes } from '@angular/router';

import { PaymentRoutes } from './components/payment/payment.routes';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { SearchInvoiceComponent } from './components/search-invoice/search-invoice.component';

export const routes: Routes = [
  ...PaymentRoutes,
  {
    path: 'search-invoice',
    component: SearchInvoiceComponent
  },
  {
      path: '**',
      component: NotFoundComponent
  }
];



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/app.routes.ts